export const gfReadOnlyFields = () => {
    let readonlyFields = document.querySelectorAll('.gf_readonly input');

    readonlyFields?.forEach((readonlyField) => {
        readonlyField.setAttribute("readonly","readonly");
    });
}
